import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '../../tailwind.config'

const fullConfig = resolveConfig(tailwindConfig)

export const screens = fullConfig.theme.screens as { [key: string]: string }

// Convert screen sizes from string (e.g., "1024px") to number
export const screenSizes = Object.entries(screens).reduce((acc, [key, value]) => {
  const size = parseInt(value.replace('px', ''))
  return { ...acc, [key]: size }
}, {} as { [key: string]: number }) 